import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components/macro";
import Center from "./Center";
import { mediaQueries } from "../styles/media.js";

function ReferralCodeBanner({ text, small, withinQuote, pageWidth = "regular" }) {
  if (!text) {
    return null;
  }

  if (small === true) {
    return (
      <StyledInlineBanner data-testid="referral-code-banner">
        <StyledEmoji>🎉</StyledEmoji>
        <StyledInlineBannerText>{text}</StyledInlineBannerText>
      </StyledInlineBanner>
    );
  }

  if (withinQuote === true) {
    return (
      <StyledQuoteBanner data-testid="referral-code-banner">
        <StyledQuoteEmoji>🎉</StyledQuoteEmoji>
        <StyledQuoteBannerText>{text}</StyledQuoteBannerText>
      </StyledQuoteBanner>
    );
  }

  return (
    <StyledFullWidthBanner data-testid="referral-code-banner">
      <StyledFullWidthBannerContent pageWidth={pageWidth}>
        <StyledEmoji>🎉</StyledEmoji>
        <StyledFullWidthBannerText>{text}</StyledFullWidthBannerText>
      </StyledFullWidthBannerContent>
    </StyledFullWidthBanner>
  );
}

const StyledEmoji = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;
  flex-shrink: 0;

  font-size: 20px;
  line-height: 1.4;

  background: var(--juno-color-white);
  width: 32px;
  height: 32px;
  overflow: hidden;
  border: 4px solid var(--juno-color-white);
  border-radius: 50%;
`;

// Full width banner

const StyledFullWidthBanner = styled.div`
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;

  margin-left: -50vw;
  margin-right: -50vw;

  ${mediaQueries.md} {
    margin-top: -30px;
    margin-bottom: 30px;
  }

  background: var(--juno-color-green);
`;

const StyledFullWidthBannerContent = styled(Center)`
  display: flex;
  align-items: center;

  padding-top: 10px;
  padding-bottom: 10px;
`;

const StyledBannerText = styled.h2`
  font-size: var(--juno-font-size-body-sm);

  ${mediaQueries.md} {
    font-size: var(--juno-font-size-body-md);
  }
  color: var(--juno-color-white);
  padding: 0 1em;
`;

const StyledFullWidthBannerText = styled(StyledBannerText)`
  text-align: left;
`;

// Inline banner

const StyledInlineBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  max-width: 38rem;

  margin-bottom: 1em;
  padding: 0 1em;

  background: var(--juno-color-green);
  border-radius: 4px;
  color: var(--juno-color-white);
`;

const StyledInlineBannerText = styled.h2`
  font-size: var(--juno-font-size-body-sm);
  padding-left: 1em;
`;

// Inside quote banner

const StyledQuoteBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  padding-top: 0.5em;
  ${mediaQueries.md} {
    padding-top: 1em;
  }
`;

const StyledQuoteEmoji = styled(StyledEmoji)`
  background: var(--juno-color-off-white);
  border-color: var(--juno-color-off-white);
`;

const StyledQuoteBannerText = styled(StyledBannerText)`
  color: var(--juno-color-text);
`;

export default ReferralCodeBanner;

ReferralCodeBanner.propTypes = {
  text: PropTypes.string,
  small: PropTypes.bool,
  withinQuote: PropTypes.bool,
  pageWidth: PropTypes.oneOf(["regular", "wider"]),
};
